import React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar as MaterialAppBar, Toolbar, Typography } from '@mui/material';
import classNames from 'classnames';

const PREFIX = 'AppBar';

const classes = {
  appBar: `${PREFIX}-appBar`,
  leftBtn: `${PREFIX}-leftBtn`,
  title: `${PREFIX}-title`,
};

const StyledMaterialAppBar = styled(MaterialAppBar)(({ theme }) => ({
  [`&.${classes.appBar}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },

  [`& .${classes.leftBtn}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.title}`]: {
    flexGrow: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));

export interface AppBarProps {
  title?: string | null;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
  titleComponent?: React.ElementType;
  elevation?: number;
  className?: string;
}

export const AppBar = (props: AppBarProps) => {
  return (
    <>
      <StyledMaterialAppBar
        elevation={props.elevation ?? 2}
        className={classNames(classes.appBar, props.className)}
        position="static"
      >
        <Toolbar>
          {props.leftElement}
          {props.title ? (
            <Typography variant="h6" component={props.titleComponent ?? 'h1'} className={classes.title}>
              {props.title}
            </Typography>
          ) : (
            <div className={classes.title} />
          )}
          {props.rightElement}
        </Toolbar>
      </StyledMaterialAppBar>
    </>
  );
};
